import React, { useState } from 'react';
import Modal from './Modal';
import { searchYouTube } from '../data/uploadService';

const fmtDur = (s) => {
  if (!s) return '';
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${m}:${String(sec).padStart(2, '0')}`;
};

// Search YouTube and pick a track to attach as a soundtrack.
export default function YouTubeSearchModal({ onClose, onPick }) {
  const [q, setQ] = useState('');
  const [results, setResults] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const run = async (e) => {
    e?.preventDefault();
    if (!q.trim()) return;
    setBusy(true);
    setError(null);
    try {
      setResults(await searchYouTube(q.trim()));
    } catch (err) {
      setError(err.message || String(err));
      setResults([]);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal title="Search YouTube" onClose={onClose}>
      <form className="cs-field" onSubmit={run} style={{ display: 'flex', gap: 8 }}>
        <input
          className="cs-input"
          placeholder="Song, artist, mix…"
          value={q}
          autoFocus
          onChange={(e) => setQ(e.target.value)}
        />
        <button className="cs-btn cs-btn-primary" type="submit" disabled={busy}>
          {busy ? '…' : 'Search'}
        </button>
      </form>

      {error && <div className="cs-empty" style={{ marginBottom: 12 }}>{error}</div>}

      <div style={{ maxHeight: 360, overflowY: 'auto' }}>
        {results === null ? (
          <div style={{ color: 'var(--muted)' }}>Search for a track to attach.</div>
        ) : results.length === 0 && !busy ? (
          <div className="cs-empty">No results.</div>
        ) : (
          results.map((r) => (
            <div
              key={r.videoId}
              style={{
                display: 'flex',
                gap: 10,
                alignItems: 'center',
                padding: '8px 4px',
                borderBottom: '1px solid #222',
              }}
            >
              {r.thumb && (
                <img
                  src={r.thumb}
                  alt=""
                  style={{ width: 96, height: 54, objectFit: 'cover', borderRadius: 4 }}
                />
              )}
              <div style={{ flex: 1, overflow: 'hidden' }}>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{r.title}</div>
                <div style={{ color: 'var(--muted)', fontSize: 12 }}>
                  {[r.channel, fmtDur(r.durationSec)].filter(Boolean).join(' · ')}
                </div>
              </div>
              <button
                className="cs-btn cs-btn-primary cs-btn-sm"
                onClick={() => onPick(r)}
              >
                Attach
              </button>
            </div>
          ))
        )}
      </div>
    </Modal>
  );
}
